import { Component, h, Host } from '@stencil/core';
@Component({
  tag: 'cr-chart-wrapper-sm',
  styleUrl: 'cr-chart-wrapper-sm.css',
  shadow: true,
})
export class CrChartWrapperSm {

  render() {
    return (
      <Host>
        <bx-tile><slot /></bx-tile>
      </Host>
    );
  }

}
